import styled, { css, keyframes } from "react-emotion";
import { isMobileDevice } from "helpers";

export const body = css`
  * {
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
  }
  height: 100%;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  margin: 0;
  padding-top: 0.1px;
`;

export const wrapper = css`
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
`;

export const inner = css`
  flex-wrap: wrap;
  display: flex;
  align-items: flex-start;
  vertical-align: top;
  position: relative;
  max-width: 100%;
  border-radius: inherit;
  text-align: left;
  padding: 4rem 3rem;
  padding-bottom: 0px;
`;

export const innerContainer = css`
  width: 100%;
  flex-shrink: 0;
  flex-grow: 0;
  max-width: 100%;
  @media only screen and (min-width: 768px) {
    width: calc(33.33333%);
  }
`;

export const innerListContainer = css`
  margin-top: 1.625rem;
  margin-bottom: 1.625rem;
  color: rgba(36, 36, 36, 0.588);
  font-size: 1.75em;
  line-height: 1.75;
  font-weight: 300;
`;

export const innerList = css`
  display: inline-block;
  max-width: 100%;
  text-align: left;
  vertical-align: middle;
  list-style: none;
`;

export const innerListItem = css`
  direction: left;
  display: flex;
  position: relative;
  ::before {
    background-image: url(data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2040%2040%22%3E%3Ccircle%20cx%3D%2220%22%20cy%3D%2220%22%20r%3D%2210%22%20fill%3D%22%231F1F1F%22%20%2F%3E%3C%2Fsvg%3E);
    border-radius: 100%;
    line-height: 3.0625rem;
    height: 3.0625rem;
    background-position: left 60%;
    background-size: contain;
    background-repeat: no-repeat;
    min-width: 1.435546875rem;
    background-repeat: no-repeat;
    content: "";
    display: block;
    position: relative;
    letter-spacing: 0 !important;
    font-variant: normal !important;
    flex-grow: 0;
    flex-shrink: 0;
  }
`;

export const innerListParagraph = css`
  padding: 0 1.09375rem;
  flex-grow: 1;
  flex-shrink: 1;
`;

export const innerContainer60 = css`
  width: 100%;
  flex-shrink: 0;
  flex-grow: 0;
  max-width: 100%;
  @media only screen and (min-width: 768px) {
    width: calc(60%);
  }
`;

export const innerContainer40 = css`
  width: 100%;
  flex-shrink: 0;
  flex-grow: 0;
  max-width: 100%;
  padding-left: 0px;
  @media only screen and (min-width: 768px) {
    width: calc(40%);
    padding-left: 6rem;
  }
`;
export const innerContainerLeft40 = css`
  width: 100%;
  flex-shrink: 0;
  flex-grow: 0;
  max-width: 100%;
  padding-right: 0px;
  @media only screen and (min-width: 768px) {
    width: calc(40%);
    padding-right: 6rem;
  }
`;

export const innerH2 = css`
  margin-top: 1.75rem;
  margin-bottom: 1.75rem;
  text-align: left;
  color: #242424;
  font-size: 1.25em;
  line-height: 1.125;
  font-weight: 400;
`;

export const fullPic = css`
  width: 100%;
  @media only screen and (min-width: 768px) {
    width: 450px;
  }
`;

export const innerContainerPadding = css`
  padding: 0px;
  @media only screen and (min-width: 768px) {
    padding: 0 0 0 3rem;
  }
`;

export const mobile_pic = css`
  margin-left: 4%;

  @media only screen and (max-width: 479px) {
    margin-left: 4%;
  }
  @media only screen and (max-width: 420px) {
    margin-left: 20%;
  }
  @media only screen and (max-width: 380px) {
    margin-left: 10%;
  }

  @media only screen and (max-width: 330px) {
    margin-left: 7%;
  }

  @media only screen and (min-width: 768px) {
    margin-left: 0%;
  }
`;

export const innerLine = css`
  margin-top: 0 !important;
  margin-bottom: 1.75rem;
  text-align: left;
  width: 100%;
  position: relative;
  padding: 0;
  border: 0;

  ::before {
    width: 2rem;
    border-top: solid 4px #9ad0d2;
    height: 2px;
    margin-top: -1px;
    content: "";
    display: inline-block;
    vertical-align: middle;
    max-width: 100%;
  }
`;

export const innerLineWhite = css`
  margin-top: 0 !important;
  margin-bottom: 1.75rem;
  text-align: left;
  width: 100%;
  position: relative;
  padding: 0;
  border: 0;

  ::before {
    width: 2rem;
    border-top: solid 4px #000000;
    height: 2px;
    margin-top: -1px;
    content: "";
    display: inline-block;
    vertical-align: middle;
    max-width: 100%;
  }
`;

export const innerDividerTop = css`
  margin-top: 0 !important;
  margin-bottom: 1.65rem;
  text-align: left;
  width: 100%;
  position: relative;
  padding: 0;
  border: 0;
  text-align: center;

  ::before {
    width: 20rem;
    border-top: solid 8px #9ad0d2;
    height: 8px;
    margin-top: -2.5px;
    content: "";
    display: inline-block;
    vertical-align: middle;
    max-width: 100%;
  }
`;
export const innerDividerBottom = css`
  margin-top: 1.65rem;
  margin-bottom: 0 !important;
  text-align: left;
  width: 100%;
  position: relative;
  padding: 0;
  border: 0;
  text-align: center;

  ::before {
    width: 20rem;
    border-top: solid 8px #9ad0d2;
    height: 8px;
    margin-top: -2.5px;
    content: "";
    display: inline-block;
    vertical-align: middle;
    max-width: 100%;
  }
`;

export const innerParagraph = css`
  margin-bottom: 20px;
  margin-top: 1.75rem;
  color: rgba(36, 36, 36, 0.588);
  font-size: 1em;
  line-height: 1.875;
  font-weight: 300;
`;

export const webWrapper = css`
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
  max-width: 1000px;
`;

export const maxWidthWrapper = css`
  max-width: 80rem;
  display: flex;
  flex-flow: row wrap;
  margin: auto;
`;

export const row = css`
  display: flex;
  flex-flow: row wrap;
  flex: 0 1 auto;
  padding: 5px 10px;
  margin-bottom: 30px;
`;
export const col = css`
  flex: 0 0 92%;
  margin: auto 4%;
  @media only screen and (min-width: 100px) {
    margin-left: 4%;
    margin-right: 0%;
    text-align: center;
  }
`;

export const customCol = css`
  flex: 0 0 92%;
  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
    text-align: center;
  }
`;
export const col_xs = css`
  @media only screen and (min-width: 768px) {
    flex: 0 0 40%;
    text-align: left;
  }
`;

export const currentFeaturesRow = css`
  padding-top: 35px;
  padding-bottom: 35px;
  @media only screen and (min-width: 768px) {
    padding: 35px 50px 35px 50px;
  }
`;

export const footer = css`
  margin-bottom: 0px;
  flex: 0 0 50px;
  margin-top: auto;
`;

export const FrameImg = styled("img")`
  position: relative;
  width: 100%;
  height: 100%;
  transition-timing-function: ease;
  transition: 0.2s;
`;

export const small = css`
  margin: 0px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 11px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #818181;
`;

export const col_ss = css`
  @media only screen and (min-width: 768px) {
    flex: 0 0 0%;
  }
`;

export const step = css`
  width: 40px;
`;

export const col1_custom = css`
  @media only screen and (min-width: 480px) {
    flex: 0 0 92%;
  }

  @media only screen and (min-width: 768px) {
    flex: 0 0 30%;
    text-align: left;
  }
`;

export const col1_custom2 = css`
  @media only screen and (min-width: 480px) {
    flex: 0 0 92%;
  }

  @media only screen and (min-width: 768px) {
    flex: 0 0 40%;
    text-align: left;
  }
`;

export const buttonRow = css`
  flex-direction: column;
  display: flex;
  justify-content: space-around;
  align-items: center;
  @media only screen and (min-width: 768px) {
    flex-direction: row;
  }
`;

export const marginBottom = css`
  margin-bottom: 20px;
  @media only screen and (min-width: 768px) {
    margin-bottom: 0px;
  }
`;

export const col1_customImg = css`
  @media only screen and (min-width: 480px) {
    flex: 0 0 92%;
  }

  @media only screen and (min-width: 768px) {
    flex: 0 0 52%;
    text-align: left;
  }
`;

export const footerNav = css`
  max-width: 1024px;
  margin: 0 auto;
`;

export const footerListNone = css`
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;
  line-height: 22px;
  font-size: 0.9375rem;

  @media only screen and (min-width: 576px) {
    text-align: left;
  }
`;

export const footerIcon = css`
  padding-right: 8px !important;
  padding-left: 8px !important;
`;

export const footerRowContainer = css`
  display: -webkit-box !important;
  display: -webkit-flex !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  height: 100%;
  -webkit-box-align: center !important;
  -webkit-align-items: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
  -webkit-box-pack: center !important;
  -webkit-justify-content: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
  line-height: 15px;
  font-size: 15px;
  color: #404040;
  border-width: 0;
`;

export const footerListItemHalf = css`
  padding-right: 6px;
  padding-left: 6px;
  margin-bottom: 16px !important;
  @media only screen and (min-width: 576px) {
    padding-right: 6px;
    padding-left: 6px;
  }

  @media only screen and (min-width: 767px) {
    padding-right: 8px;
    padding-left: 8px;
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 50%;
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }

  @media only screen and (min-width: 1360px) {
    padding-right: 8px;
    padding-left: 8px;
  }

  @media only screen and (min-width: 992px) {
    padding-right: 8px;
    padding-left: 8px;
  }
`;

export const footerBottomRow = css`
  padding: 0;
  margin: 0;
  list-style: none;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -6px;
  margin-left: -6px;
  padding-top: 16px !important;
  padding-bottom: 16px !important;

  @media only screen and (min-width: 576px) {
    margin-right: -6px;
    margin-left: -6px;
  }

  @media only screen and (min-width: 767px) {
    margin-right: -8px;
    margin-left: -8px;
  }

  @media only screen and (min-width: 992px) {
    margin-right: -8px;
    margin-left: -8px;
  }

  @media only screen and (min-width: 1360px) {
    margin-right: -8px;
    margin-left: -8px;
  }
`;

export const footerOrder1 = css`
  order: 2;
  @media only screen and (min-width: 576px) {
    order: 0;
  }
`;
export const footerOrder2 = css`
  order: 0;
  @media only screen and (min-width: 576px) {
    order: 1;
  }
`;
export const footerOrder3 = css`
  order: 1;
  @media only screen and (min-width: 576px) {
    order: 2;
  }
`;
export const footerOrder4 = css`
  order: 3;
`;

export const footerListItemLinks = css`
  display: flex;
  justify-content: center;
`;

export const footerListItem = css`
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-bottom: 12px !important;
  @media only screen and (min-width: 576px) {
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 25%;
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }

  @media only screen and (min-width: 576px) {
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 25%;
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }

  @media only screen and (min-width: 1360px) {
    padding-right: 8px;
    padding-left: 8px;
  }

  @media only screen and (min-width: 992px) {
    padding-right: 8px;
    padding-left: 8px;
  }

  /* @media only screen and (min-width: 767px) {
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 16.66666667%;
    -ms-flex: 0 0 16.66666667%;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  } */

  @media only screen and (min-width: 767px) {
    padding-right: 8px;
    padding-left: 8px;
  }

  @media only screen and (min-width: 576px) {
    padding-right: 6px;
    padding-left: 6px;
  }
`;

export const footerATag = css`
  text-decoration: none;
  cursor: pointer;
  color: black;
`;

export const footerList = css`
  margin-right: -6px;
  margin-left: -6px;
  justify-content: center;
  text-align: left;
  float: none;
  padding: 0;
  margin: 0;
  list-style: none;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;

  padding-right: 16px !important;
  padding-left: 16px !important;

  @media only screen and (min-width: 767px) {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  @media only screen and (min-width: 576px) {
    margin-right: -6px;
    margin-left: -6px;
  }
  @media only screen and (min-width: 767px) {
    margin-right: -8px;
    margin-left: -8px;
  }

  @media only screen and (min-width: 992px) {
    margin-right: -8px;
    margin-left: -8px;
  }

  @media only screen and (min-width: 1360px) {
    margin-right: -8px;
    margin-left: -8px;
  }
`;

export const col1_half = css`
  @media only screen and (min-width: 480px) {
    flex: 0 0 92%;
  }

  @media only screen and (min-width: 768px) {
    flex: 0 0 65%;
    text-align: left;
  }
`;

export const half_col = css`
  @media only screen and (min-width: 480px) {
    flex: 0 0 92%;
  }

  @media only screen and (min-width: 768px) {
    flex: 0 0 46%;
    text-align: left;
  }
`;

export const col1_4 = css`
  @media only screen and (min-width: 480px) {
    flex: 0 0 92%;
  }

  @media only screen and (min-width: 768px) {
    flex: 0 0 50%;
    text-align: left;
  }
`;

export const styledUnderline = css`
  background-image: linear-gradient(
    to right,
    rgba(137, 210, 211, 0.4) 75%,
    rgba(137, 210, 211, 0.4) 75%
  );
  background-position: 0 0.9em;
  background-repeat: repeat-x;
  -webkit-background-size: 1px 0.147em;
  background-size: 1px 0.147em;
`;

export const heroImage = css`
  object-fit: contain;
  display: flex !important;
`;

export const customImage = css`
  object-fit: contain;
  display: flex !important;
  width: 100%;
`;

export const appsImage = css`
  object-fit: contain;
  width: 200px;
  @media only screen and (max-width: 479px) {
    width: 175px;
  }
  @media only screen and (min-width: 768px) {
    width: 425px;
  }
`;

export const col3pic = css`
  text-align: center;
  @media only screen and (min-width: 768px) {
    flex: 0 0 39%;
    text-align: left;
  }
`;
export const col3pic_custom = css`
  text-align: center;
  @media only screen and (min-width: 768px) {
    flex: 0 0 60%;
    text-align: left;
  }
`;

export const col3pic_half = css`
  text-align: center;
  @media only screen and (min-width: 768px) {
    flex: 0 0 27%;
    text-align: left;
  }
`;

export const WebHeader = styled("header")`
  padding: 15px 20px;
  justify-content: space-between;
  position: sticky;
  background-color: white;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 200;
  align-items: center;
  box-shadow: 0px 5px 8px -8px rgb(0, 0, 0, 0.75);

  a {
    text-decoration: none;
  }
  @media only screen and (min-width: 768px) {
    padding: 0px 55px 0px 55px;
    height: 170px;
  }
  @media (max-width: 767px) {
    padding: 0px 10px;
  }
`;

export const header = css`
  margin-bottom: 15px;
`;

export const col1_2left = css`
  @media only screen and (min-width: 300px) {
    text-align: center;
  }
  @media only screen and (min-width: 480px) {
    flex: 0 0 92%;
  }
  @media only screen and (min-width: 768px) {
    flex: 0 0 46%;
    text-align: left;
  }
`;

export const col1_2right = css`
  padding-top: 60px;
  @media only screen and (min-width: 480px) {
    flex: 0 0 92%;
  }
  @media only screen and (min-width: 768px) {
    flex: 0 0 46%;
  }
`;

export const buttonContainer = css`
  display: flex;
  justify-content: flex-end;
  width: auto;
  margin: auto;
`;

export const col1_4_pic = css`
  padding-top: 60px;
  @media only screen and (min-width: 480px) {
    flex: 0 0 92%;
    /* padding-top: 0px; */
  }
  @media only screen and (min-width: 768px) {
    flex: 0 0 36%;
    padding-top: 0px;
  }
`;

export const flexyRowCol = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media only screen and (min-width: 768px) {
    flex-direction: row;
  }
`;
export const flexyRowBlock = css`
  display: block;
  @media only screen and (min-width: 768px) {
    flex-direction: row;
    display: flex;
    flex-direction: row;
  }
`;

export const googlePlayStore = css`
  margin-bottom: 20px;
  padding-left: 0px;
  @media only screen and (min-width: 768px) {
    padding-left: 20px;
    margin-bottom: 0px;
  }
`;

export const appleStore = css`
  margin-bottom: 20px;
  @media only screen and (min-width: 768px) {
    margin-bottom: 0px;
  }
`;

const bounce = keyframes`
  from, 20%, 53%, 80%, to {
    transform: translate3d(0,0,0);
  }

  40%, 43% {
    transform: translate3d(0, -30px, 0);
  }

  70% {
    transform: translate3d(0, -15px, 0);
  }

  90% {
    transform: translate3d(0,-4px,0);
  }
`;

export const bouncingArrow = css`
  animation: ${bounce} 1s ease infinite;
`;

export const mdcButtonLabel = css`
  color: white;
`;
export const slideContainer = css`
  text-align: center;
  width: 100%;
`;

export const sliderLabel = css`
  margin-bottom: 0px;
  padding-top: 15px;
  justify-content: space-between;
  width: 85%;
  margin-left: 7%;
`;

export const slider = css`
  -webkit-appearance: none;
  width: 85%;
  height: 8px;
  border-radius: 5px;
  background: rgba(137, 210, 211, 0.3);
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #89d2d3;
    cursor: pointer;
  }
  ::-moz-range-thumb {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #4caf50;
    cursor: pointer;
  }
`;

export const hostElement = css`
  margin: auto;
  width: 230px;
  height: 470px;
  background-repeat: no-repeat;
  margin-bottom: 50px;
  background-image: url("https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/carousel/frame.png");
`;

export const mdcButtonLabelFree = css`
  font-size: 12px;
  color: white;
`;

export const materialIcons = css`
  vertical-align: middle;
  padding-bottom: 3px;
  margin-right: auto;
`;

export const H1MainHeader = styled("h1")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 40px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.25px;
  color: #000000;
  @media only screen and (max-width: 330px) {
    font-size: 40px;
  }
  @media only screen and (min-width: 768px) {
    font-size: 48px;
  }
  ::selection {
    background: rgba(74, 124, 246, 0.1);
    color: rgb(137, 210, 211);
  }
`;

export const H1 = styled("h1")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 40px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  @media only screen and (min-width: 768px) {
    font-size: 48px;
  }
`;

export const H2LeftToCenter = styled("h2")`
  font-size: 30px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  text-align: center;
  @media only screen and (min-width: 768px) {
    font-size: 38px;
    margin: 30px 0px;
    text-align: left;
  }
  ::selection {
    background: rgba(74, 124, 246, 0.1);
    color: rgb(137, 210, 211);
  }
`;

export const H2 = styled("h2")`
  font-size: 30px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  @media only screen and (min-width: 768px) {
    font-size: 38px;
    margin: 30px 0px;
  }
  ::selection {
    background: rgba(74, 124, 246, 0.1);
    color: rgb(137, 210, 211);
  }
`;
export const H3 = styled("h3")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  display: block;
  font-size: 24px;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  @media only screen and (min-width: 768px) {
    font-size: 32px;
  }
`;
export const ColoredH3 = styled("h3")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  color: #89d2d3;
  display: block;
  font-size: 24px;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  @media only screen and (min-width: 768px) {
    font-size: 32px;
  }
`;
export const H4 = styled("h4")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 22px;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  @media only screen and (min-width: 768px) {
    font-size: 28px;
  }
`;
export const ColoredH4 = styled("h4")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  color: #89d2d3;
  display: block;
  font-size: 22px;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  @media only screen and (min-width: 768px) {
    font-size: 28px;
  }
`;
export const H5 = styled("h5")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  @media only screen and (min-width: 768px) {
    font-size: 22px;
  }
`;
export const ColoredH5 = styled("h5")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  color: #89d2d3;
  font-size: 26px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  @media only screen and (min-width: 768px) {
    font-size: 26px;
  }
`;

export const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;

export const AButton = styled("a")`
  text-decoration: none;
  display: inline-block;
`;

export const loginSignupMenu = css`
  display: inline-block;
`;

export const subscribeInput = css`
  margin-right: 20px;
  width: 350px;
  height: 36px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  padding: 5px 15px;
  outline: none;
  border-style: none;
  border-radius: 4px;
  background-color: #ebebeb;
  font-size: 14px;
  margin-bottom: 15px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;

  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
      Verdana, sans-serif;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.4px;
    color: #153143;
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
      Verdana, sans-serif;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.4px;
    color: #153143;
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
      Verdana, sans-serif;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.4px;
    color: #153143;
  }
  :-moz-placeholder {
    /* Firefox 18- */
    font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
      Verdana, sans-serif;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.4px;
    color: #153143;
  }
`;
export const iphone = css`
  width: 175px;
`;

export const col1 = css`
  @media only screen and (min-width: 768px) {
    text-align: center;
  }
  @media only screen and (min-width: 300px) {
    text-align: center;
  }
`;

export const offwhite = css`
  background-color: #f6fbfb;
  /* background-color: red; */
`;

export const col3 = css`
  @media only screen and (min-width: 300px) {
    text-align: center;
  }
  @media only screen and (min-width: 480px) {
    flex: 0 0 92%;
  }
  @media only screen and (min-width: 768px) {
    flex: 0 0 54%;
    text-align: left;
  }
`;

export const mdcButton = css`
  background-color: rgb(235, 255, 255);
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  width: auto;
`;

export const mdcListItem = css`
  width: 214px;
  padding-top: 11px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  @media only screen and (min-width: 480px) {
    width: 100%;
    display: block;
  }
  @media only screen and (max-width: 400px) {
    width: 100%;
    display: block;
  }
`;

export const footerLogo = css`
  width: 35px;
  height: 35px;
  margin-bottom: 12px;
  float: left;
  /* @media only screen and (max-width: 400px) {
    width: 0px;
  } */
`;

export const socialMediaItem = css`
  padding-right: 8px !important;
  padding-left: 8px !important;
  padding: 0;
  margin: 0;
  list-style: none;
  line-height: 22px;
`;

export const socialMediaList = css`
  display: -webkit-box !important;
  display: -webkit-flex !important;
  display: -ms-flexbox !important;
  display: flex !important;
  padding: 0;
  margin: 0;
  list-style: none;
  -webkit-box-pack: center !important;
  -webkit-justify-content: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
  -webkit-box-align: center !important;
  -webkit-align-items: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
`;

export const footerText = css`
  font-size: 10px;
  margin: 0px;
  line-height: 19px;
  @media only screen and (max-width: 400px) {
    text-align: center;
  }
`;
export const headerLogoPic = css`
  cursor: pointer;
  margin: 15px;
  margin-left: 18px;
  margin-right: 0px;
  object-fit: contain;
  width: 150px;
  @media only screen and (min-width: 975px) {
    width: 200px;
    margin-left: 33px;
  }
  @media only screen and (min-width: 768px) {
    width: 175px;
    margin-left: 33px;
  }
`;

export const webHeaderLogoPic = css`
  cursor: pointer;
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  border-radius: 10px;
  margin: 15px;
  width: 50px;
  object-fit: contain;

  @media only screen and (min-width: 768px) {
    width: 75px;
    margin: 10px;
  }
`;

export const col1_4_header = css`
  @media only screen and (min-width: 320px) {
    flex: 0 0 73%;
  }
  @media only screen and (min-width: 344px) and (max-width: 479px) {
    flex: 0 0 74%;
  }

  @media only screen and (min-width: 480px) {
    margin-left: 7px;
    flex: 0 0 48%;
    text-align: left;
  }
  @media only screen and (min-width: 620px) {
    margin-left: 4%;
    flex: 0 0 24%;
    text-align: left;
  }
`;
export const addScreens = css`
  width: 100%;
  @media only screen and (min-width: 692px) {
    width: 315px;
  }
  @media only screen and (min-width: 940px) {
    width: 400px;
  }
`;

export const col3header = css`
  text-align: center;
  @media only screen and (min-width: 320px) {
    flex: 0 0 0%;
  }
  @media only screen and (min-width: 344px) and (max-width: 479px) {
    flex: 0 0 0%;
  }

  @media only screen and (min-width: 480px) {
    flex: 0 0 44%;
    text-align: left;
  }
  /* @media only screen and (min-width: 620px) {
    flex: 0 0 65%;
    text-align: left;
  } */
  @media only screen and (min-width: 768px) {
    flex: 0 0 65%;
    text-align: left;
  }
  @media only screen and (max-width: 945px) {
    flex: 0 0 60%;
    text-align: left;
  }
  @media only screen and (min-width: 946px) {
    flex: 0 0 69%;
    text-align: left;
  }
`;

// TUTORIALS
export const frameStyle = css`
  @media only screen and (min-width: 480px) {
    width: 90%;
  }
  @media only screen and (min-width: 768px) {
    width: 100%;
  }
`;
export const frameStyleLanding = css`
  @media only screen and (min-width: 480px) {
    width: 90%;
    height: 300px;
  }
  @media only screen and (min-width: 768px) {
    width: 80%;
    height: 500px;
  }
`;

export const imageCropper = css`
  width: 50px;
  height: 50px;
  position: relative;
  overflow: hidden;
  border-radius: 50%;
  margin-bottom: 10px;
  @media only screen and (min-width: 768px) {
    width: 75px;
    height: 75px;
  }
`;

export const logoStyle = css`
  margin: 0 auto;
  height: 100%;
  width: auto;
`;
export const arrowStyle = css`
  font-size: 1.3em;
  display: flex;
  align-self: flex-end;
  margin-top: 10px;
  margin-bottom: 10px;
  @media only screen and (min-width: 768px) {
    font-size: 2em;
    cursor: pointer;
    display: flex;
    align-self: flex-end;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

export const storeContainer = css`
  margin: 0px 20px;
  @media only screen and (min-width: 768px) {
    margin: 0px 40px;
  }
`;
